import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {withStyles, Button, Drawer, Typography} from '@material-ui/core'
import Add from '@material-ui/icons/Add'

import {FormElement, PageContainer} from '../../../components/components'
import TabContainer, {Title} from '../TabContainer'
import FormElementType from '../../../components/FormElement/FormElementType'
import {apiResourcesUrl} from '../../../core/request'
import classNames from 'classnames'

const styles = {
    submitButton: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '5em',
        alignSelf: 'center',
        alignItems: 'center',
        color: '#fff'
    },

    addIcon: {
        marginLeft: '0.5em'
    },

    addText: {
        marginLeft: '0.5em'
    },

    pageContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        transitionDuration: '1s',
        paddingTop: '1em',
        paddingBottom: '2em'
    },

    pageInnerContainer: {
        paddingTop: '1em'
    },

    formContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        width: '55%'
    }
}


class MediaUpdate extends Component {
    state = {
        isDisabled: false,
        isOpen: false
    }

    coverIcon = () => {
        const {projectDetails} = this.props
        return {
            label: <Fragment>Drag & Drop your <span className="filepond--label-action">Cover Image/Icon </span> or <span className="filepond--label-action"> Browse </span></Fragment>,
            name: 'coverImage',
            elementType: FormElementType.ImageDropper,
            defaultImg: projectDetails ? `${apiResourcesUrl}/cover-arts/${projectDetails.coverUrl}` : null,
            imagePreviewSize: 'iconLarge'
        }
    }

    screenShot = screenshot => {
        const {projectDetails} = this.props
        return {
            label: <Fragment>Drag & Drop your <span className="filepond--label-action">New Screenshot </span> or <span className="filepond--label-action"> Browse </span></Fragment>,
            name: `screenshot${screenshot.id}`,
            elementType: FormElementType.ImageDropper,
            defaultImg: `${apiResourcesUrl}/${projectDetails.id}/screenshots/${screenshot.imgUrl}`,
            defaultCaption1: screenshot.caption1,
            defaultCaption2: screenshot.caption2,
            save: this.onSaveScreenshot(screenshot.id),
            onDelete: this.onDeleteScreenshot(screenshot.id),
            multiple: false,
            hasCaption: true,
            withDropZone: false
        }
    }

    coverIconInput = {}
    screenShotsInput = {}
    newScreenShotInput = {}

    onSaveCoverImage = () => {
        const formData = new FormData()
        if (this.coverIconInput.state.value.length > 0) {
            formData.append(this.coverIconInput.props.name, this.coverIconInput.state.value[0])
            this.props.editProjectDetails(this.props.projectDetails.id, formData)
        }
    }

    onSaveScreenshot = id => () => {
        const formData = new FormData()
        const input = this.screenShotsInput[id]
        const newCaption1 = input.imageDropper.captions[0].formFieldsInputs.caption1.state.value
        const newCaption2 = input.imageDropper.captions[0].formFieldsInputs.caption2.state.value
        formData.append('screenshot[id]', id)
        formData.append('screenshot[caption1]', newCaption1)
        formData.append('screenshot[caption2]', newCaption2)
        if (input.state.value.length > 0) {
            formData.append('screenshotImage', (input.state.value[0]))
        }
        this.props.editProjectDetails(this.props.projectDetails.id, formData)
    }

    onSubmitScreenshot = () => {
        const formData = new FormData()
        console.log(this.newScreenShotInput)
        const caption1 = this.newScreenShotInput.imageDropper.captions[0].formFieldsInputs.caption1.state.value
        const caption2 = this.newScreenShotInput.imageDropper.captions[0].formFieldsInputs.caption2.state.value
        formData.append('screenshot[caption1]', caption1)
        formData.append('screenshot[caption2]', caption2)
        formData.append('newScreenshot', this.newScreenShotInput.state.value[0])
        this.props.editProjectDetails(this.props.projectDetails.id, formData, this.toggleForm(false))
    }

    newScreenShotField = {
        label: <Fragment>Drag & Drop your <span className="filepond--label-action">New Screenshot </span> or <span className="filepond--label-action"> Browse </span></Fragment>,
        name: 'newScreenShot',
        elementType: FormElementType.ImageDropper,
        save: this.onSubmitScreenshot,
        multiple: false,
        hasCaption: true
    }

    onDeleteScreenshot = id => () => {
        const formData = new FormData()
        formData.append('screenshot[id]', id)
        formData.append('screenshot[delete]', 1)

        this.props.editProjectDetails(this.props.projectDetails.id, formData)
    }

    toggleForm = isOpen => () => {
        this.setState({isOpen})
        this.newScreenShotInput.clear()
    }

    onAddClick = () => {
        this.setState({isOpen: true})
    }

    render () {
        const {classes: styles, active, projectDetails} = this.props
        const {isOpen} = this.state
        const projectName = projectDetails ? projectDetails.name : ''

        return (
            <TabContainer active={active} title={'Update Cover Icon'}>
                <FormElement {...this.coverIcon()} innerRef={ref => (this.coverIconInput = ref || this.coverIconInput)} save={this.onSaveCoverImage} withDropZone={false} />

                <Title>Update Screenshots</Title>

                <Button className={styles.submitButton} color={'primary'} variant={'contained'} onClick={this.onAddClick}>
                    <span className={styles.addText}>Add New Screenshot</span>
                    <Add className={styles.addIcon} />
                </Button>

                <div>
                    {projectDetails && projectDetails.screenshots.map(screenshot => (
                        <FormElement
                            key={screenshot.id}
                            {...this.screenShot(screenshot)}
                            innerRef={ref => (this.screenShotsInput[screenshot.id] = ref)}
                        />
                    ))}
                </div>
                <Drawer
                    anchor="bottom"
                    open={isOpen}
                    onClose={this.toggleForm(false)}
                    onOpen={this.toggleForm(true)}
                    disableEnforceFocus
                    keepMounted
                >

                    <PageContainer className={styles.pageContainer} containerClassName={styles.pageInnerContainer}>
                        <Typography variant={'h6'} color={'primary'} className={classNames(styles.featuresFormTitle, styles.formTitle)}>
                         Add New Screenshot for {projectName}
                        </Typography>
                        <div className={styles.formContainer}>
                            <FormElement {...this.newScreenShotField} innerRef={ref => (this.newScreenShotInput = ref || this.newScreenShotInput)} />
                        </div>
                    </PageContainer>

                </Drawer>
            </TabContainer>
        )
    }
}

MediaUpdate.propTypes = {
    classes: PropTypes.object,
    active: PropTypes.bool,
    metas: PropTypes.array,
    projectDetails: PropTypes.object
}

export default withStyles(styles)(MediaUpdate);
